import { Component, GameObject, IVector2, System } from "../../tsthree";
import { FTUTutorialSystem } from "../Systems/FTUTutorialSystem";
import { Container, DisplayObject, Graphics, NineSlicePlane, Sprite, Text } from "pixi.js";
import { Scopey } from "../Prefabs/Scopey";
import TaggedText from "pixi-tagged-text";
import { TutorialStageComponent } from "./TutorialStageComponent";

export class FTUTutorialComponent extends Component {

    public static readonly id: string = "component";
    protected static readonly _system: typeof System = FTUTutorialSystem;

    public stage: number = -1;
    public arbitraryStageId: string | null = null;
    public currentTargets: {
        obj: GameObject,
        pos: IVector2,
        scale: IVector2,
        parent: Container
    }[] = [];
    public currentPositionSetting: "top-left" | "top" | "top-right" = "top-left";

    public spotlight: Graphics;
    public rectSpotlight: Graphics;
    public overlay: Graphics;
    public arrow: Sprite;
    public popup: Container;
    public popupNineslice: NineSlicePlane;
    public scopey: Scopey;
    public text: TaggedText;
    public skipButtonText: TaggedText;
    public nextButtonText: TaggedText;
    public nextButtonContainer: Container;
    public skipButtonContainer: Container;

    public cachedPos: IVector2 = null;
    public timer: number = 0;

    onAttach(): void {
    }

    onComponentAttached(_componentId: string, _component: Component): void {
    }

    onDetach(): void {
    }

    public start(): void {
        this.stage = 0;
    }

}